window.fixFooterPadder = function () {
    var bodyWrapper = jQuery('.outer-wrapper');
    var footer = jQuery('footer.footer');

    bodyWrapper.css('padding-bottom', footer.outerHeight() + 'px');

    if (jQuery('#wpadminbar').length) {
        jQuery('html').attr('style', 'margin: 0 !important;');
        jQuery('body').css('padding-top', '32px');
    }
};

(function ($) {
    $(document).ready(function () {
        window.fixFooterPadder();
        setTimeout(window.fixFooterPadder, 2000);
        setTimeout(window.fixFooterPadder, 5000);
    });
    $(window).ready(window.fixFooterPadder);
    $(window).on('load', window.fixFooterPadder);
    $(window).resize(window.fixFooterPadder);
})(jQuery);
